import React from 'react';
import { ButtonBase, List, ListItem, ListItemAvatar, Avatar, ListItemText, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PaymentIcon from '@mui/icons-material/Payment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import InfoIcon from '@mui/icons-material/Info';

function OptionsAdmin({ userId, username, onOptionClick, onBackClick, onLogout }) {
    return (
        <div>
            <ButtonBase onClick={() => { onBackClick(); onOptionClick('back'); }} style={{ padding: '20px', color: 'black' }}>
                <ArrowBackIcon />
            </ButtonBase>
            <List>
                <ListItem button onClick={() => onOptionClick('SalesChat')} style={{ padding: '20px' }}>
                    <ListItemAvatar>
                        <Avatar></Avatar>
                    </ListItemAvatar>
                    {username && <ListItemText primary={username} secondary="My account" style={{ color: 'black', fontWeight: 'bold' }} />}
                </ListItem>
            </List>
            <Divider variant="middle" />
            <List>
                <ListItem button onClick={() => onOptionClick('ProvinciaDeliveries')} style={{ padding: '20px' }}>
                    <PaymentIcon style={{ color: 'lightgray', marginRight: '10px' }} />
                    <ListItemText primary="Payments" style={{ color: 'black' }} />
                </ListItem>
                <ListItem button onClick={() => onOptionClick('ControlTower')} style={{ padding: '20px' }}>
                    <AccessTimeIcon style={{ color: 'lightgray', marginRight: '10px' }} />
                    <ListItemText primary="My Pick-ups" style={{ color: 'black' }} />
                </ListItem>
                <ListItem button onClick={() => onOptionClick('DeliveryList')} style={{ padding: '20px' }}>
                    <AccessTimeIcon style={{ color: 'lightgray', marginRight: '10px' }} />
                    <ListItemText primary="My Deliveries" style={{ color: 'black' }} />
                </ListItem>
                <ListItem button onClick={() => onOptionClick('Routes')} style={{ padding: '20px' }}>
                    <SupportAgentIcon style={{ color: 'lightgray', marginRight: '10px' }} />
                    <ListItemText primary="Routes" style={{ color: 'black' }} />
                </ListItem>
                <ListItem button onClick={onLogout} style={{ padding: '20px' }}>
                    <InfoIcon style={{ color: 'lightgray', marginRight: '10px' }} />
                    <ListItemText primary="About" style={{ color: 'black' }}/>
                </ListItem>
            </List>
        </div>
    );
}

export default OptionsAdmin;